import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Image, Modal, Popup, Segment, TextArea,Message} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import AddNewReceipt from './add_new_receipt';
import placeHolder from "../../assets/placeholderImage.png";
import {uploadReceiptsDetails} from "../../data/report_api";
import Loader from "../universal/loader";
import ImageUploadDropzone from './image_upload_dropzone';

const uuidv1 = require('uuid/v1');

class Receipt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showReceiptSection: false,
            showEdit: undefined,
            receiptDesc: undefined,
            imageEdit: undefined,
            imageFile: undefined,
            failedUploads:[],
            imgErrorMsg:undefined,
            errorMsg:undefined
        }
    }

    componentWillMount() {
        this.setState({showReceiptSection: this.props.showReceipts});
    }


    updateReceiptDetail = (receipt) => {
        if (!receipt['action']) {
            receipt['action'] = 'update';
        }
        receipt['description'] = this.state.receiptDesc;
        this.props.updateReceiptInReport(receipt);
    };

    deleteReceipt = (receipt) => {
        this.props.deleteReceiptInReport(receipt);
    };

    uploadReceipts = () => {
        this.setState({isSaving:true,errorMsg:undefined});
        let newUploadableReceipts = JSON.parse(JSON.stringify(this.props.updateReceipts));
        let uploadableReceipts = newUploadableReceipts.receipts;
        let images = [];
        for (let i = 0; i < uploadableReceipts.length; i++) {
            if (uploadableReceipts[i]['images']) {
                const image = this.props.updateReceipts.receipts[i]['images'];
                if (!image['image_path']) {
                    images.push(image);
                }
                uploadableReceipts[i]['images'] = {id: uploadableReceipts[i]['images']['id']}
            }
        }
        newUploadableReceipts.receipts = uploadableReceipts;
        if (newUploadableReceipts.receipts.length > 0 || images.length > 0) {

            uploadReceiptsDetails(newUploadableReceipts).then((response) => {
                if (response.success) {
                    if (images.length > 0) {
                        for (let i = 0; i < images.length; i++) {
                            const formData = new FormData();
                            formData.append("id", images[i].id);
                            formData.append("file", images[i].file);
                            if(i === images.length-1){
                                this.props.uploadImages(formData, this.completeCallBack);
                            }
                            else {
                                this.props.uploadImages(formData, this.successFn);
                            }
                        }
                    }
                    else {
                        this.completeCallBack(response,undefined);
                    }
                } else {
                    {this.setState({errorMsg:response.statusMessage || "There was an error while saving, please try again",isSaving:false})}
                }
            }).catch((e)=>{
                {this.setState({errorMsg:"There was an error while saving, please try again",isSaving:false})}
            });
        }
        else {
            this.setState({isSaving:false});
            this.props.handleClose();
        }
    };

    updateReceiptImage = (file, receipt) => {
        let fr = new FileReader();
        if (file) {
            fr.onload = (e) => {
                file['dataURL'] = e.target.result;
                const image = {
                    id: uuidv1(),
                    file: file,
                    dataURL: e.target.result
                };
                this.setState({imageFile: image});
            };
            fr.readAsDataURL(file);
        }
        setTimeout(() => {
            if (!receipt['action']) {
                receipt['action'] = 'update';
            }
            receipt['images'] = this.state.imageFile;
            this.props.updateReceiptInReport(receipt);
            this.setState({imageEdit: undefined});
        }, 1000);

    };

    completeFn = () => {
        this.props.resetDataQueuedInAPI('receipts');
        this.setState({isSaving:false});
        this.props.handleClose();
    };

    successFn = (response, image) => {
        if (!response.success) {
            this.setState({failedUploads:[...this.state.failedUploads, image]})
        }
    };

    exitWindow = () =>{
        this.props.resetDataQueuedInAPI('receipts');
        this.setState({isSaving:false});
        this.props.handleClose();
    }

    completeCallBack = (response,image) => {

        if (!response.success && image) {
            let error = undefined
            let err = response.statusMessage
            if (err.response) {
                error = err.response.data.error || "An error occurred on the server.";
            } else if (err.request) {
                error = "Network error: Please check your internet connection.";
            } else {
                error = err.message || "An unknown error occurred.";
            }
            this.setState({failedUploads:[...this.state.failedUploads, image], isSaving:false, imgErrorMsg:error})
        } else {
            this.props.resetDataQueuedInAPI('receipts');
            this.setState({isSaving:false});
            this.props.handleClose();
        }
    };

    retryImageUpload = () =>{
        let images = [...this.state.failedUploads]
        this.setState({isSaving:true,imgErrorMsg:undefined,failedUploads:[]})
        if (images.length > 0) {
            for (let i = 0; i < images.length; i++) {
                if(i === images.length-1){
                    this.props.uploadImages(images[i], this.completeCallBack);
                }
                else {
                    this.props.uploadImages(images[i], this.successFn);
                }
            }
        }
        else {
            this.completeCallBack({success:true});
        }

    }

    render() {
        const receipts = this.props.reportDetails.receipts;
        return (<Segment>
            {this.state.isSaving && <Loader save={true}/>}
            <Modal size="large" open={this.state.showReceiptSection} onClose={(e) => {
                this.uploadReceipts();
            }}>
                <Modal.Content style={{minHeight: '500px', overflowY: 'scroll'}}>
                    <Header floated="right"><Icon className="icon-button" name="save" onClick={(e) => {
                        this.uploadReceipts();
                    }}/></Header>
                    <Modal.Description>
                        <Header as='h2' textAlign='center'>
                            Receipts
                        </Header>
                         {this.state.errorMsg && <Message>There was an error while saving receipt details, please try again.   {this.state.errorMsg} <hr/>  <Button compact onClick={this.uploadReceipts}>Retry Save</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                                                {this.state.failedUploads.length > 0 && <Message> {this.state.failedUploads.length} Image(s) failed to upload, try again? {this.state.imgErrorMsg}<hr/> <Button compact onClick={this.retryImageUpload}>Retry Upload</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                        {receipts ? receipts.map((receipt, i) => {
                            return (<Segment key={receipt['client_id']} className="receipt-segment">
                                                                             {this.state.imageEdit === receipt['client_id'] ?<ImageUploadDropzone handlerFunction={(file) => {
                                                this.updateReceiptImage(file, receipt)
                                            }}/>:
                                <div ref={receipt['client_id']}>
                                    <Grid style={{marginTop: '0'}}>
                                        <Grid.Column width={4}>
                                            <Image
                                                src={(receipt['images'] && receipt['images']['image_path']) ?receipt['images']['image_path'] : ((receipt['images'] && receipt['images']['file']) ? receipt['images']['file']['type']!="application/pdf"? receipt['images']['file']['dataURL']:placeHolder : placeHolder)}
                                                rounded
                                                width="100px" height="100px"/>
                                        </Grid.Column>
                                        <Grid.Column width={12}>
                                            <Header textAlign="left">
                                                Description

                                                <Popup
                                                    trigger={<Icon size="small" name="trash" style={{fontSize: '1.2em'}}
                                                                   className="icon-button info-grey pull-right"/>}
                                                    content={<Button negative content="Confirm Delete?"
                                                                     onClick={() => {
                                                                         this.deleteReceipt(receipt)
                                                                     }}/>}
                                                    on="click"
                                                    position="left center"
                                                    hideOnScroll
                                                />
                                                <Icon name="image" size="small" className="icon-button pull-right"
                                                      onClick={() => {
                                                          this.setState({imageEdit: receipt['client_id']});
                                                      }}/>
                                            </Header>
                                            {this.state.showEdit === receipt['client_id'] &&
                                            <Form onSubmit={() => {
                                                this.updateReceiptDetail(receipt)
                                            }}>
                                                    <TextArea style={{verticalAlign: 'middle',marginTop:"15px"}}
                                                              defaultValue={receipt['description']}
                                                              placeholder="Receipt Description"
                                                              autoFocus fluid rows={3}
                                                              onFocus={(e) => {
                                                                  this.setState({receiptDesc: e.target.value})
                                                              }}
                                                              onChange={(e) => {
                                                                  this.setState({receiptDesc: e.target.value})
                                                              }}
                                                              onBlur={() => {
                                                                  this.setState({showEdit: undefined});
                                                                  this.updateReceiptDetail(receipt);
                                                              }}
                                                              required
                                                    />
                                            </Form>
                                            }
                                            {this.state.showEdit !== receipt['client_id'] &&
                                            <span onClick={(e) => {
                                                this.setState({showEdit: receipt['client_id']});
                                            }
                                            }>{receipt['description']}</span>}
                                        </Grid.Column>
                                    </Grid>
                                </div>}
                            </Segment>);
                        }) : null}
                        <AddNewReceipt/>
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </Segment>);
    }
}

export default ReportContainer(Receipt);


// WEBPACK FOOTER //
// ./src/views/report/receipts.js